export default __webpack_public_path__ + "static/bussiness_valuation-69922505380da1e137ba4d323e6ac736.png";